// extracted by mini-css-extract-plugin
export default {"markdown":"_290c3617d5487ba5","link":"_1dbc937add4674db"};